const { vec4 } = require('glov/common/vmath.js');
const { spritesheetRegister } = require('glov/client/spritesheet.js');
module.exports = {
  name: 'solitude',
  tiles: {
    abyss_lightcyan7: 0,
    altar0: 1,
    altar1: 2,
    altar2: 3,
    altar3: 4,
    crystal_floor1: 5,
    crystal_floor3: 6,
    crystal_floor5: 7,
    crystal_wall0: 8,
    crystal_wall1: 9,
    crystal_wall3: 10,
    crystal_wall7: 11,
    crystal_wall9: 12,
    fire0: 13,
    fire1: 14,
    fire2: 15,
    fire3: 16,
    fire4: 17,
    fire5: 18,
    fire6: 19,
    fire7: 20,
    gateway: 21,
    marble1: 22,
    marble2: 23,
    marble3: 24,
    marble4: 25,
    maze_map: 26,
    shoals_shallow_water00: 27,
    shoals_shallow_water01: 28,
    shoals_shallow_water02: 29,
    treeanim00: 30,
    treeanim01: 31,
    treeanim02: 32,
    treeanim03: 33,
    treeanim04: 34,
    treeanim05: 35,
    treeanim06: 36,
    treeanim07: 37,
    treeanim08: 38,
    treeanim09: 39,
    treeanim10: 40,
    treeanim11: 41
  },
  uidata: {
    rects: [
      vec4(8/1024,8/256,40/1024,40/256),
      vec4(56/1024,8/256,88/1024,40/256),
      vec4(104/1024,8/256,136/1024,40/256),
      vec4(152/1024,8/256,184/1024,40/256),
      vec4(200/1024,8/256,232/1024,40/256),
      vec4(248/1024,8/256,280/1024,40/256),
      vec4(296/1024,8/256,328/1024,40/256),
      vec4(344/1024,8/256,376/1024,40/256),
      vec4(392/1024,8/256,424/1024,40/256),
      vec4(440/1024,8/256,472/1024,40/256),
      vec4(488/1024,8/256,520/1024,40/256),
      vec4(536/1024,8/256,568/1024,40/256),
      vec4(584/1024,8/256,616/1024,40/256),
      vec4(632/1024,8/256,664/1024,40/256),
      vec4(680/1024,8/256,712/1024,40/256),
      vec4(728/1024,8/256,760/1024,40/256),
      vec4(776/1024,8/256,808/1024,40/256),
      vec4(824/1024,8/256,856/1024,40/256),
      vec4(872/1024,8/256,904/1024,40/256),
      vec4(920/1024,8/256,952/1024,40/256),
      vec4(968/1024,8/256,1000/1024,40/256),
      vec4(8/1024,56/256,40/1024,88/256),
      vec4(56/1024,56/256,88/1024,88/256),
      vec4(104/1024,56/256,136/1024,88/256),
      vec4(152/1024,56/256,184/1024,88/256),
      vec4(200/1024,56/256,232/1024,88/256),
      vec4(248/1024,56/256,280/1024,88/256),
      vec4(296/1024,56/256,328/1024,88/256),
      vec4(344/1024,56/256,376/1024,88/256),
      vec4(392/1024,56/256,424/1024,88/256),
      vec4(440/1024,56/256,504/1024,112/256),
      vec4(520/1024,56/256,584/1024,112/256),
      vec4(600/1024,56/256,664/1024,112/256),
      vec4(680/1024,56/256,744/1024,112/256),
      vec4(760/1024,56/256,824/1024,112/256),
      vec4(840/1024,56/256,904/1024,112/256),
      vec4(920/1024,56/256,984/1024,112/256),
      vec4(8/1024,128/256,72/1024,184/256),
      vec4(88/1024,128/256,152/1024,184/256),
      vec4(168/1024,128/256,232/1024,184/256),
      vec4(248/1024,128/256,312/1024,184/256),
      vec4(328/1024,128/256,392/1024,184/256)
    ],
    aspect: [
                       1,                  1,                  1,
                       1,                  1,                  1,
                       1,                  1,                  1,
                       1,                  1,                  1,
                       1,                  1,                  1,
                       1,                  1,                  1,
                       1,                  1,                  1,
                       1,                  1,                  1,
                       1,                  1,                  1,
                       1,                  1,                  1,
      1.1428571428571428, 1.1428571428571428, 1.1428571428571428,
      1.1428571428571428, 1.1428571428571428, 1.1428571428571428,
      1.1428571428571428, 1.1428571428571428, 1.1428571428571428,
      1.1428571428571428, 1.1428571428571428, 1.1428571428571428
    ]
  },
  FRAME_ABYSS_LIGHTCYAN7: 0,
  FRAME_ALTAR0: 1,
  FRAME_ALTAR1: 2,
  FRAME_ALTAR2: 3,
  FRAME_ALTAR3: 4,
  FRAME_CRYSTAL_FLOOR1: 5,
  FRAME_CRYSTAL_FLOOR3: 6,
  FRAME_CRYSTAL_FLOOR5: 7,
  FRAME_CRYSTAL_WALL0: 8,
  FRAME_CRYSTAL_WALL1: 9,
  FRAME_CRYSTAL_WALL3: 10,
  FRAME_CRYSTAL_WALL7: 11,
  FRAME_CRYSTAL_WALL9: 12,
  FRAME_FIRE0: 13,
  FRAME_FIRE1: 14,
  FRAME_FIRE2: 15,
  FRAME_FIRE3: 16,
  FRAME_FIRE4: 17,
  FRAME_FIRE5: 18,
  FRAME_FIRE6: 19,
  FRAME_FIRE7: 20,
  FRAME_GATEWAY: 21,
  FRAME_MARBLE1: 22,
  FRAME_MARBLE2: 23,
  FRAME_MARBLE3: 24,
  FRAME_MARBLE4: 25,
  FRAME_MAZE_MAP: 26,
  FRAME_SHOALS_SHALLOW_WATER00: 27,
  FRAME_SHOALS_SHALLOW_WATER01: 28,
  FRAME_SHOALS_SHALLOW_WATER02: 29,
  FRAME_TREEANIM00: 30,
  FRAME_TREEANIM01: 31,
  FRAME_TREEANIM02: 32,
  FRAME_TREEANIM03: 33,
  FRAME_TREEANIM04: 34,
  FRAME_TREEANIM05: 35,
  FRAME_TREEANIM06: 36,
  FRAME_TREEANIM07: 37,
  FRAME_TREEANIM08: 38,
  FRAME_TREEANIM09: 39,
  FRAME_TREEANIM10: 40,
  FRAME_TREEANIM11: 41
};
spritesheetRegister(module.exports);
